import React, { FC } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { QuickSearchInput } from '../../yourborrowbox/localcontent/product/QuickSearchInput';
import { LCDD } from '../../yourborrowbox/localcontent/shared/LCDD';
import { useTranslation } from 'react-i18next';

const StQuickSearchContainer = styled.li.attrs({
    'data-displayname': 'DropDownWithSearch'
})`
    position: absolute;
    margin: -2px;
    cursor: inherit;
    top: 0;
    padding: 2px !important;
    width: 100%;
`;

const StNoMatchesFoundContainer = styled.li``;

const StLCDD = styled(LCDD)<{ minWidth: number }>`
    .dropdown-list {
        min-width: ${props => props.minWidth}px;
    }

    .dropdown-list-inner {
        font-size: 12px;
        margin-top: 30px;
    }
`;

export type Item = {
    code: string;
    name: string;
};

interface Props {
    fetchItems?: () => void;
    onSearch: (searchTerm: string) => void;
    onClear: () => void;
    onClose: () => void;
    handleItemClick: (item: Item) => void;
    items: Item[];
    selectedItem: string | undefined;
    itemKey: string;
    disabled?: boolean;
    minWidth: number;
}

export const DropdownWithSearch: FC<Props> = ({ fetchItems = () => {}, ...props }) => {
    const { t } = useTranslation();

    const items = props.items.filter(item => item.name !== props.selectedItem);

    return (
        <>
            <StLCDD
                preventCloseDropdown={true}
                onOpenListener={() => fetchItems()}
                onCloseListener={props.onClose}
                label={<span>{props.selectedItem ?? t('yourLocalContent.yourTitles.select')}</span>}
                className={classNames('dropdown-lc lc-input')}
                buttonClassname={classNames('green-fill', { disabled: props.disabled })}
                minWidth={props.minWidth}
            >
                <ul>
                    <StQuickSearchContainer>
                        <QuickSearchInput onSearch={props.onSearch} onClear={props.onClear} />
                    </StQuickSearchContainer>
                    {items.length > 0 ? (
                        items.map(x => (
                            <li data-close-dropdown key={x[props.itemKey]} onClick={() => props.handleItemClick(x)}>
                                <i className="strong">+&nbsp;</i>&nbsp;{x.name}
                            </li>
                        ))
                    ) : (
                        <StNoMatchesFoundContainer className="cold-grey">No matches found.</StNoMatchesFoundContainer>
                    )}
                </ul>
            </StLCDD>
            <div style={{ clear: 'both' }} />
        </>
    );
};
